export default "__VITE_ASSET__U895l8s8__"